interface Props {
  color: string
  x?: number
  y?: number
  scale?: number
}

export default function IconPlus({ color, x = 5.6, y = 5.6, scale = 0.7 }: Props) {
  return (
    <g transform={`translate(${x}, ${y}) scale(${scale})`} stroke={color} strokeWidth={1.5}>
      <path d="M5 12h14" vectorEffect="non-scaling-stroke"></path>
      <path d="M12 5v14" vectorEffect="non-scaling-stroke"></path>
    </g>
  )
}
